/* eslint-disable */
export default {
  allCalls: 'All calls',
  Unknown: 'Unknown',
  Multiple: 'Multiple',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
